import {
	globalColors,
	globalColorsNBD,
	invertedThemeColors,
	invertedThemeColorsNBD,
	mainThemeColors,
	mainThemeColorsNBD,
} from '@volkswagen-onehub/tokens';

const isInvertedThemeForm = (): boolean => false;

export const isNewBrandDesign = (): boolean => {
	return true;

	// const config = JSON.parse(document.getElementById('spaModel')?.textContent || '{}');
	// return config?.spaGlobalConfig?.marketBasedFeatures?.activateNewBrandDesign;
};

export const COLOR_TOKEN = {
	...(isInvertedThemeForm()
		? isNewBrandDesign()
			? invertedThemeColorsNBD
			: invertedThemeColors
		: isNewBrandDesign()
			? mainThemeColorsNBD
			: mainThemeColors),
};

export const hexWithOpacity = (hex: string, opacity: number): string => {
	const alpha = Math.round(opacity * 255)
		.toString(16)
		.padStart(2, '0');
	return `${hex.replace('#', '#')}${alpha}`;
};

// --- CUSTOM ---
// alerts.tsx / user-section.tsx
export const contrastBackground = isNewBrandDesign()
	? COLOR_TOKEN.background.secondary
	: COLOR_TOKEN.background.primary;

// novedades.tsx
export const novedadesBackgroundColor = isNewBrandDesign()
	? `linear-gradient(180deg, ${COLOR_TOKEN.background.tertiary} 0%, ${COLOR_TOKEN.background.highlight} 67%)`
	: `linear-gradient(180deg, ${COLOR_TOKEN.background.primary} 0%, ${COLOR_TOKEN.background.disabled} 67%)`;

// benefits.tsx
export const benefitsBackgroundColor = isNewBrandDesign()
	? COLOR_TOKEN.background.highlight
	: COLOR_TOKEN.background.disabled;

// bonus-card.tsx
export const bonusCardBackgroundColor = isNewBrandDesign()
	? COLOR_TOKEN.background.tertiary
	: COLOR_TOKEN.background.primary;

// hucha (card, pdf & popup)
export const huchaLinesColor = isNewBrandDesign() ? globalColorsNBD.newHorizon['50'] : COLOR_TOKEN.focus.main;

// renovadores-label.tsx
export const huchaRenovadoresLabelBackgroundColor = isNewBrandDesign()
	? globalColorsNBD.newHorizon['50']
	: COLOR_TOKEN.background.backplate;

// accordion-styled.tsx
export const focusColorWithOpacity10 = hexWithOpacity(COLOR_TOKEN.focus.main, 0.1);
export const accordionCardBackgroundColor = isNewBrandDesign()
	? COLOR_TOKEN.background.card.primary
	: focusColorWithOpacity10;
export const accordionCTABackgroundColor = isNewBrandDesign()
	? COLOR_TOKEN.button.primary.default
	: COLOR_TOKEN.focus.main;
export const accordionCTAInnerColor = isNewBrandDesign() ? COLOR_TOKEN.content.inverted : COLOR_TOKEN.content.primary;
export const accordionCTAInnerHoverColor = isNewBrandDesign()
	? COLOR_TOKEN.content.primary
	: COLOR_TOKEN.content.inverted;

// services-animated-background.tsx
export const stain1Color = isNewBrandDesign()
	? hexWithOpacity(globalColorsNBD.red['20'], 0.35)
	: hexWithOpacity(globalColors.mint['100'], 0.2);
export const stain3Color = isNewBrandDesign()
	? hexWithOpacity(COLOR_TOKEN.focus.main, 0.35)
	: globalColors.green['100'];
export const stain2Color = isNewBrandDesign()
	? globalColorsNBD.yellow['20']
	: hexWithOpacity(COLOR_TOKEN.focus.main, 0.35);

// vips.tsx
export const vipsBackgroundColor = isNewBrandDesign() ? COLOR_TOKEN.gradient.top : COLOR_TOKEN.accent.nbab.default;

// data-collection-progress-bar.tsx
export const dataCollectionProgressBarBackgroundColor = isNewBrandDesign()
	? {
			level0: `linear-gradient(90deg, ${COLOR_TOKEN.background.offer} 0%, ${COLOR_TOKEN.accent.offer.default} 100%)`,
			level1: `linear-gradient(90deg, ${COLOR_TOKEN.accent.offer.default} 0%, ${COLOR_TOKEN.border.legalframe} 100%)`,
			level2: `linear-gradient(90deg, ${COLOR_TOKEN.accent.offer.default} 0%, ${COLOR_TOKEN.displayTag.bookmark.background} 100%)`,
			level3: `linear-gradient(90deg, ${COLOR_TOKEN.accent.offer.default} 0%, ${COLOR_TOKEN.displayTag.success.background} 100%)`,
		}
	: {
			level0: 'linear-gradient(90deg, #fffae5 0%, #ffd100 100%)',
			level1: 'linear-gradient(90deg, #ffd100 0%, #ff335c 100%)',
			level2: 'linear-gradient(90deg, #ff335c 0%, #00e6e6 100%)',
			level3: 'linear-gradient(90deg, #fffae5 0%, #ffd100 25%, #ff335c 50%, #00e6e6 75%, #0082d6 100%)',
		};

// serviceHeader.ts
export const progressColor = isNewBrandDesign() ? COLOR_TOKEN.signal.progress : '#ffaa27';

// person-vehicle.tsx
export const signalErrorColorWithOpacity10 = hexWithOpacity(COLOR_TOKEN.signal.error, 0.1);
export const contentSecondaryWithOpacity10 = hexWithOpacity(COLOR_TOKEN.content.secondary, 0.1);

// dataCollectionForm.tsx
export const dataCollectionFormBackgroundColor = isNewBrandDesign()
	? COLOR_TOKEN.background.highlight
	: COLOR_TOKEN.accent.nbab.default;

/*
Usos externos:
- isNewBrandDesign() se usa en alert-card.tsx para condicionar la sompra
- isNewBrandDesign() se usa en bonus-card.tsx para para condicionar la sompra
- isNewBrandDesign() se usa en vips.tsx para definir el tema de ThemeProvider
*/
